import React, { useState } from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import "./style.scss";
import SizeGuidePopup from "../sizeguidepopup";

export default function AccessoriesInner({
  categoryName = "Accessories Inner Category",
  products = [],
  categoryDescription = "",
}) {
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  function toggleSizeGuide() {
    setShowSizeGuide(!showSizeGuide);
  }
  return (
    <div className="accessories-inner">
      <Navbar />
      <SizeGuidePopup
        show={showSizeGuide}
        onClickClose={toggleSizeGuide}
        accessories
      />
      <div className="accessories-inner__content">
        <h1 className="heading-primary">{categoryName}</h1>
        <p className="accessories-inner__des">{categoryDescription}</p>
        <button className="accessories-inner__btn" onClick={toggleSizeGuide}>
          SIZE GUIDE
        </button>
        <div className="accessories-inner__container">
          <div className="row">
            {products.map((item, i) => (
              <div className="col col-12 col-md-4">
                <div className="accessories-inner__product">
                  <div className="accessories-inner__product__img">
                    <img alt="category product" src={item.img} />
                  </div>
                  <div className="accessories-inner__product__name">
                    {item.name}
                  </div>
                  <div className="accessories-inner__product__description">
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
